(function (window, document, undefined) {


L.Cyclone = L.Cyclone || {};


L.Cyclone.iconCase = function(data) {
    return null;
    /*
    if (data.ws >= 51)
        return L.icon({
            iconUrl: 'ty-l.png',
            iconSize: [16, 16]
        });
    else if (data.ws >= 32.7)
        return L.icon({
            iconUrl: 'ty-m.png',
            iconSize: [16, 16]
        });
    else if (data.ws >= 17.2)
        return L.icon({
            iconUrl: 'ty-s.png',
            iconSize: [16, 16]
        });
    else
        return L.icon({
            iconUrl: 'td.png',
            iconSize: [16, 16]
        });
    */
};


/**
*
* Add some useful method
*
*/
L.LatLng.prototype.clone = function () {
    return new L.LatLng(this.lat, this.lng);
};
L.LatLng.prototype.add = function (latlng) {
    return this.clone()._add(L.latLng(latlng));
};
L.LatLng.prototype._add = function (latlng) {
    this.lat += latlng.lat;
    this.lng += latlng.lng;
    return this;
};
L.LatLng.prototype.subtract = function (latlng) {
    return this.clone()._subtract(L.latLng(latlng));
};
L.LatLng.prototype._subtract = function (latlng) {
    this.lat -= latlng.lat;
    this.lng -= latlng.lng;
    return this;
};


L.Cyclone.Radius = (L.Layer ? L.Layer : L.Class).extend({
    options: {
        density: 3,
        unitConverter: function(radii) {
            //
            // The default unit of Cyclone Radius is kilometers,
            // adn sould convert to meter if using Leaflet Circle
            //
            return radii * 1000.0;
        },
        smoothFactor: 0.3
    },

    initialize: function (latlng, radii, options) {
        var self = this;
        L.setOptions(self, options);
        self._latlng = L.latLng(latlng);
        self._radii = radii;
        self._layers = [];

        if (self.options.great_circle) {
            //
            // 使用地球大圓距離計算圓圈的 Path, 不直接使用 L.Circle
            //
            self._create_fan(latlng, radii, self.options);
        }
        else {
            if (typeof(radii) == 'object') {
                // 多象限複合圓, using Polygon
                self._create_fan(latlng, radii, self.options);
            }
            else {
                if (self.options.great_circle) {
                    self._create_fan(latlng, radii, self.options);
                }
                else {
                    if (self.options.unitConverter) {
                        radii = self.options.unitConverter(radii);
                    }
                    self.addLayer(L.circle(latlng, radii, self.options));
                }
            }
        }
    },

    addLayer: function (layer) {
        this._layers.push(layer);

        if (this._map) {
            this._map.addLayer(layer);
        }

        return this;
    },

    clearLayers: function () {
        this.eachLayer(this.removeLayer, this);
        return this;
    },

    onAdd: function (map) {
        this._map = map;
        this.eachLayer(map.addLayer, map);
    },

    onRemove: function (map) {
        this.eachLayer(map.removeLayer, map);
        this._map = null;
    },

    addTo: function (map) {
        map.addLayer(this);
        return this;
    },

    eachLayer: function (method, context) {
        for (var i in this._layers) {
            method.call(context, this._layers[i]);
        }
        return this;
    },

    setZIndex: function (zIndex) {
        return this.invoke('setZIndex', zIndex);
    },

    setLatLng: function(latlng) {
        var self = this;
        latlng = L.latLng(latlng);
        var _shif = latlng.subtract(self._latlng);
        self._latlng = latlng;
        self.eachLayer(function(layer) {
            if (layer instanceof L.Circle) {
                layer.setLatLng(latlng);
            }
            else {
                let _lls = layer.getLatLngs();
                for (let idx in _lls) {
                    if (Array.isArray(_lls[idx])) {
                        for (let _idx in _lls[idx]) {
                            _lls[idx][_idx]._add(_shif);
                        }
                    }
                    else {
                        _lls[idx]._add(_shif);
                    }
                }
                layer.setLatLngs(_lls);
            }
        });
    },

    _create_fan: function(latlng, radii, options) {
        var self = this,
            density = options.density;
        latlng = latlng.clone();

        if (typeof(radii) == 'object') {
            // pass
        }
        else {
            radii = [radii];
        }

        var deg2rad = Math.PI / 180.0,
            rlon = latlng.lng * deg2rad,
            rlat = latlng.lat * deg2rad,
            degree_delta = 360.0 / radii.length;

        var polys = [],
            avaliable_radii_num = 0;
        if (radii.length > 0) {
            for (var i = 0; i < radii.length; i++) {
                var r = Math.round(radii[i]);
                if (r <= 0) {
                    polys.push(latlng);
                    continue;
                }

                avaliable_radii_num ++;

                var degree_from = i * degree_delta;
                var degree_to = degree_from + degree_delta;
                var degree = degree_from;
                for (; degree<=degree_to; degree+=density) {
                    var point = self.__calc_fan_point(rlon, rlat,
                        degree * deg2rad, r);
                    polys.push(point);
                }
            }
        }
        if (avaliable_radii_num > 0) {
            self.addLayer(L.polygon(polys, options));
        }

        return self;
    },

    __calc_fan_point: function(clon_rad, clat_rad, theta, distance) {
        var a = Math.sin(clat_rad),
            b = Math.cos(clat_rad),
            c = distance / 6372.795,
            lat = Math.asin(a * Math.cos(c) +
                            b * Math.cos(theta) * Math.sin(c)),
            lon = clon_rad + Math.atan2(b * Math.sin(theta) * Math.sin(c),
                                        Math.cos(c) - a * Math.sin(lat));
        return [lat * 180.0 / Math.PI, lon * 180.0 / Math.PI];
    }
});
L.Cyclone.radius = function (latlng, radii, options) {
    return new L.Cyclone.Radius(latlng, radii, options);
};


/*
 * Create an L.Marker of Cyclone and extend ObservedPrototype
 *   data: an dict with lon, lat, ws, radii
 *   options:
 *       iconCase: a function that get icon by ws
 *       radius: Could be number or a dict contain diff type of radius
 *   event:
 *       marker-moved: fired while this marker moved
 *       marker-data-setted : fired while setData is called from outside
 */
L.Cyclone.Marker = L.Marker.extend({

    options: {
        tagVisible: false,
        iconCase: L.Cyclone.iconCase,
        radius: {
            visible: true,
            // Also could be
            //    visible: {
            //        r7: true
            //        r10: false
            //    }

            //
            // Here is a special property to convert real radius data value
            // to meter for L.circle.
            // Exp(trans km to meter):
            //    unitConverter : function(val) { return val * 1000; }
            //
            unitConverter: null
        },
        markerMove: null
    },

    initialize: function (data, options) {
        L.setOptions(this, options);

        this.options.radius = L.extend({}, options.radius);

        this._radius_layers = {};
        this._data = L.extend({
            lat: null,
            lon: null,
            ws: null,
            radius: null
        }, this._data, data);
        this._initData(data, true);
    },

    _initData: function(data, force) {
        var self = this, changeds = {};

        if (typeof(data.lat) !== 'undefined') {
            if (self._data.lat != data.lat) {
                self._data.lat = data.lat;
                changeds.lat = true;
            }
        }
        if (typeof(data.lon) !== 'undefined') {
            if (self._data.lon != data.lon) {
                self._data.lon = data.lon;
                changeds.lon = true;
            }
        }
        if (typeof(data.ws) !== 'undefined') {
            if (self._data.ws != data.ws) {
                self._data.ws = data.ws;
                changeds.ws = true;
            }
        }

        if (typeof(data.radius) !== 'undefined') {
            if (self._data.radius) {
                delete self._data.radius;
                self._data.radius = null;
            }
            self._data.radius = data.radius;
            changeds.radius = true;
        }

        if (self._data.lon !== null && self._data.lat !== null) {
            self._latlng = L.latLng([self._data.lat, self._data.lon]);
        }
        else {
            self._latlng = null;
        }

        self._refresh(changeds, force);

        return self;
    },

    setData: function(data) {
        this._initData(data);
    },

    getData: function() {
        return this._data;
    },

    setIcon: function (icon) {
        // not allow to change icon
        return this;
    },

    setEditable: function(editable) {
        this.options.draggable = editable;
        if (this._map && this.dragging) {
            if (editable) {
                this.dragging.enable();
                this.on('move', this._markerMove);
                this.on('dragend', this._markerMove);
            }
            else {
                this.dragging.disable();
                this.off('move', this._markerMove);
                this.off('dragend', this._markerMove);
            }
            this._highlight(editable);
        }
        return this;
    },

    _highlight: function(editable) {
        var self = this;
        if (editable) {

        }
        else {
        }
    },

    // setHighlight: function(highlight) {
    //     this.options.highlight = highlight;
    //     if (this._icon) {
    //         if (highlight) {
    //             L.DomUtil.addClass(this._icon, 'highlight');
    //         }
    //         else {
    //             L.DomUtil.removeClass(this._icon, 'highlight');
    //         }
    //     }
    // },

    showMarker: function() {
        if (this._map) {
            this._map.addLayer(this);
        }
    },
    hideMarker: function() {
        if (this._map) {
            this._map.removeLayer(this);
        }
    },
    setRadiusVisible: function(visible_options) {
        if (typeof(visible_options) == 'object') {
            if (typeof(this.options.radius.visible) != 'object') {
                this.options.radius.visible = visible_options;
            }
            else {
                for (var key in visible_options) {
                    this.options.radius.visible[key] = visible_options[key];
                }
            }
        }
        else {
            this.options.radius.visible = visible_options;
        }
        this._addRadiusToMap();
    },

    _markerMove: function(e) {
        var latlng = this.getLatLng();
        this._data.lat = latlng.lat;
        this._data.lon = latlng.lng;

        for (var key in this._radius_layers) {
            if (this._radius_layers[key]) {
                this._radius_layers[key].setLatLng(latlng);
            }
        }
    },

    _refresh: function(changeds, force) {
        if (!changeds || force) {
            changeds = {
                lat: true,
                lon: true,
                ws: true,
                radius: true
            }
        }

        if (changeds.radius) {
            for (var key in this._radius_layers) {
                if (this._radius_layers[key]) {
                    if (this._map) {
                        this._map.removeLayer(this._radius_layers[key]);
                    }
                    this._radius_layers[key] = null;
                }
            }
            this._radius_layers = {};

            if (this._map) {
                this._initRadius();
            }
        }

        if (changeds.ws) {
            this.options.icon = this.options.iconCase(this._data);
            if (this.options.icon) {
                if (this._map) {
                    if (this._icon) {
                        if (this.dragging) {
                            this.dragging.disable();
                        }
                        this._removeIcon();
                    }
                    this._initIcon();
                    // force to relocate icon
                    changeds.lat = changeds.lon = true;
                }
            }
        }

        if (changeds.lat || changeds.lon) {
            this.update();
        }
    },

    _initRadius: function() {
        if (typeof(this._data.radius) == 'object') {
            for (var key in this._data.radius) {
                if (this.options.radius.unitConverter) {
                    this.options.radius[key].unitConverter = this.options.radius.unitConverter;
                }
                var _radii = this._data.radius[key];
                if (_radii) {
                    if (typeof(_radii) == 'object') {
                        this._radius_layers[key] = L.Cyclone.radius(this._latlng,
                            _radii, this.options.radius[key]);
                    }
                    else if (_radii > 0) {
                        this._radius_layers[key] = L.Cyclone.radius(this._latlng,
                            _radii, this.options.radius[key]);
                    }
                }
            }
        }
        else if (this._data.radius && this._data.radius > 0) {
            this._radius_layers[0] = L.Cyclone.radius(this._latlng,
                this._data.radius, this.options.radius);
        }
        this._addRadiusToMap();
    },

    _addRadiusToMap: function() {
        if (this._map) {
            var visible = this.options.radius.visible;
            for (var key in this._radius_layers) {
                var _radius = this._radius_layers[key];
                if (_radius) {
                    if (visible) {
                        if (visible === true || visible[key]) {
                            this._map.addLayer(_radius);
                        }
                        else {
                            this._map.removeLayer(_radius);
                        }
                    }
                    else {
                        this._map.removeLayer(_radius);
                    }
                }
            }
        }
    },

    onAdd: function (map) {
        this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;

        if (this._zoomAnimated) {
            map.on('zoomanim', this._animateZoom, this);
        }

        this.on('move', this._markerMove);
        this.on('dragend', this._markerMove);

        this._initRadius();

        this._initIcon();
        this.update();
    },

    onRemove: function (map) {
        if (this.dragging && this.dragging.enabled()) {
            this.options.draggable = true;
            this.dragging.removeHooks();
        }
        delete this.dragging;

        if (this._zoomAnimated) {
            map.off('zoomanim', this._animateZoom, this);
        }

        this.off('move', this._markerMove);
        this.off('dragend', this._markerMove);

        for (var key in this._radius_layers) {
            if (this._radius_layers[key]) {
                map.removeLayer(this._radius_layers[key]);
            }
        }
        this._radius_layers = {};

        this._removeIcon();
        this._removeShadow();
    },
    //
    // _bringToFront: function () {
    //     var offset = this.options.riseOffset;
    //     if (this.options.toFront) {
    //         offset += this.options.riseOffset;
    //     }
    //     this._updateZIndex(offset);
    // },
    //
    // _resetZIndex: function () {
    //     var offset = 0;
    //     if (this.options.toFront) {
    //         offset += this.options.riseOffset;
    //     }
    //     this._updateZIndex(offset);
    // }

});

/*
 * Create Track extend by L.Path,
 * and this track contain the L.Cyclone.Marker.
 * Special Options:
 *     hidePath: show marker only
 *
 * Events:
 *     track-data-changed
 */
L.Cyclone.Track = L.Polyline.extend({
    _data: {
        points: {
            // dtime: {
            //     lat   : number (require)
            //     lon   : number (require)
            //     ws    : number (optional)
            //     radius: number or dict (optional)
            // }
        }
    },

    options: {
        markerOptions: {
            iconCase: L.Cyclone.iconCase,
            listenEvents: []
        },
        markerVisible: true,
        radiusVisible: false,
        editable: false
    },

    initialize: function (data, options) {
        var self = this;

        self._markers = {};
        if (options && options.hidePath) {
            options.opacity = 0;
            options.weight = 0;
        }
        L.Polyline.prototype.initialize.call(self, [], options);
        //
        // init marker event response here
        //
        self.on('marker-moved', this._markerMove);
        self.on('marker-data-setted', this._markerDataSetted);

        self.setData(data);
    },

    onAdd: function (map) {
        this._map = map;

        this._renderer._initPath(this);
        this._reset();

        if (!this.options.hidePath) {
            this._project();
            this._updatePath();
        }

        if (this.options.markerVisible) {
            for (var dtime in this._markers) {
                map.addLayer(this._markers[dtime]);
            }
        }
        this._renderer._addPath(this);
    },

    onRemove: function () {
        for (var dtime in this._markers) {
            this._map.removeLayer(this._markers[dtime]);
        }
        this._renderer._removePath(this);
    },

    getPointData: function(dtime) {
        return this._data.points[dtime];
    },

    getPointMarker: function(dtime) {
        return this._markers[dtime];
    },

    getPointMarkerLayers: function() {
        return this._markers;
    },

    // disable this method
    addLatLng: function (latlng) {
        return null;
    },

    setData: function(data) {
        var _latlngs = [];
        this._data = data;

        var have_to_remove = [], dtime;
        for (dtime in this._markers) {
            if (!data.points[dtime]) {
                have_to_remove.push(dtime);
            }
        }
        for (var i in have_to_remove) {
            dtime = have_to_remove[i];
            if (this._map) {
                this._map.removeLayer(this._markers[dtime]);
            }
            this._markers[dtime] = null;
            delete this._markers[dtime];
        }

        for (dtime in data.points) {
            var point = data.points[dtime];
            _latlngs.push([point.lat, point.lon]);
            this.resetMarker(dtime, point);
        }
        this._latlngs = this._convertLatLngs(_latlngs);
        return this.redraw();
    },

    resetMarker: function(dtime, point) {
        var self = this,
            _point_data = L.extend({}, point);

        if (self.options.markerVisible) {
            if (self._markers[dtime]) {
                self._markers[dtime]._initData(_point_data);
            }
            else {
                var _marker = new L.Cyclone.Marker(_point_data,
                    self.options.markerOptions);
                if (self.options.editable) {
                    _marker.setEditable(true);
                }
                _marker.setRadiusVisible(self.options.radiusVisible);

                // attach event listen
                if (_marker.attach) {
                    _marker.attach('marker-moved', self);
                    _marker.attach('marker-data-setted', self);
                }

                if (self._map) {
                    self._map.addLayer(_marker);
                }
                self._markers[dtime] = _marker;
            }
        }
    },

    setMarkerVisible: function(visible) {
        this.options.markerVisible = visible;
        if (visible) {
            for (var dtime in this._markers) {
                if (this._map) {
                    this._map.addLayer(this._markers[dtime]);
                }
            }
        }
        else {
            for (var dtime in this._markers) {
                if (this._map) {
                    this._map.removeLayer(this._markers[dtime]);
                }
            }
        }
    },

    setRadiusVisible: function(visible) {
        this.options.radiusVisible = visible;

        for (var dtime in this._markers) {
            this._markers[dtime].setRadiusVisible(visible);
        }
    },

    getData: function() {
        return this._data;
    },

    setEditable: function(editable) {
        this.options.editable = editable;
        for (var dtime in this._markers) {
            this._markers[dtime].setEditable(editable);
        }
    },

    setUniqueEditable: function(dtime) {
        this.options.editable = editable;
        for (var dtime in this._markers) {
            if (dtime == dtime) {
                this._markers[dtime].setEditable(true);
            }
            else {
                this._markers[dtime].setEditable(false);
            }
        }
    },

    _markerMove: function(e) {
        var _latlngs = [], marker_data;
        for (var dtime in this._data.points) {
            var point_data = this._data.points[dtime];
            if (this._markers[dtime]) {
                marker_data = this._markers[dtime].getData();
                point_data.lat = marker_data.lat;
                point_data.lon = marker_data.lon;
                _latlngs.push([marker_data.lat, marker_data.lon]);
            }
            else {
                _latlngs.push([point_data.lat, point_data.lon]);
            }
        }
        this._latlngs = this._convertLatLngs(_latlngs);
        this.fire('track-data-changed', e);
        return this.redraw();
    },

    _markerDataSetted: function(e) {
        var _latlngs = [], marker_data;
        for (var dtime in this._data.points) {
            if (this._markers[dtime]) {
                marker_data = this._markers[dtime].getData();
                this._data.points[dtime] = L.extend({}, marker_data);
                _latlngs.push([marker_data.lat, marker_data.lon]);
            }
            else {
                var point_data = this._data.points[dtime];
                _latlngs.push([point_data.lat, point_data.lon]);
            }
        }
        this._latlngs = this._convertLatLngs(_latlngs);
        return this.redraw();
    }
});

/*
 * Create MultiOptionTrack extend by L.FeatureGroup,
 * and this track contain the L.Cyclone.Track.
 */
L.Cyclone.MultiOptionTrack = L.FeatureGroup.extend({

    initialize: function (data, options) {
        this._data = L.extend({}, this._data, data);
        var copyBaseOptions = options.multiOptions.copyBaseOptions;

        this._layers = {};
        this._options = options;
        if (copyBaseOptions === undefined || copyBaseOptions) {
            this._copyBaseOptions();
        }

        this.setPoints(data.points);
    },

    _options: {
        multiOptions: {
            obs: {
            },
            fcst: {
                dashArray: '10, 5'
            }
        },
        markerVisible: true,
        radiusVisible: false,
        editable: false
    },

    _copyBaseOptions: function () {
        var multiOptions = this._options.multiOptions,
            baseOptions;

        baseOptions = L.extend({}, this._options);
        delete baseOptions.multiOptions;

        for (var type in multiOptions) {
            if (!multiOptions.hasOwnProperty(type)) { continue; }
            multiOptions[type] = L.extend({}, baseOptions, multiOptions[type]);
        }
    },

    setPoints: function (points) {
        var dt,
            multiOptions = this._options.multiOptions;

        this._originalPoints = points;

        this.eachLayer(function (layer) {
            this.removeLayer(layer);
        }, this);

        var obs_points = {points:{}},
            fcst_points = {points:{}};

        var pre_point = {}, pre_dt = null;
        for (dt in points) {
            if (!points.hasOwnProperty(dt)) continue;
            var point = points[dt];

            if (point.type == "obs") {
                obs_points.points[dt] = point;
            }
            else if (point.type == "fcst") {

                // set obs track's last point be fcst track's first point.
                if (pre_point.type == "obs") {
                    fcst_points.points[pre_dt] = pre_point;
                }
                fcst_points.points[dt] = point;
            }
            // default points
            else {
                obs_points.points[dt] = point;
            }

            pre_point = point;
            pre_dt = dt;
        }

        if (obs_points.points)
            var obs_track = new L.Cyclone.Track(obs_points, multiOptions.obs);
            this.addLayer(obs_track);

        if (fcst_points.points)
            var fcst_track = new L.Cyclone.Track(fcst_points, multiOptions.fcst);
            this.addLayer(fcst_track);

        return this;
    },

    getData: function() {
        return this._data;
    },

    getPointData: function(dtime) {
        return this._data.points[dtime];
    }
});


}(this, document));



// WEBPACK FOOTER //
// ./src/assets/cb/leaflet/leaflet-cyclone.js